// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3dwPX","left":"InfoRow_left__1WNMA"};